import React, { Component} from "react";
import MUIDataTable from "mui-datatables";
import {
	createMuiTheme,
	MuiThemeProvider,
		withStyles
} from "@material-ui/core/styles";
import api from '../common/api';
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import Typography from "@material-ui/core/Typography";
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import TextField from "@material-ui/core/TextField";
import EventIcon from '@material-ui/icons/Event';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Backdrop from '@material-ui/core/Backdrop';

const useStyles = theme => ({
	menu:{
		fontSize:'0.75rem',
	}
});
  



class WorkOrderAlerts extends React.Component {

	constructor() {
      super();

      this.state = {
        loaded: false,
	    backdrop: false,
        work_order_alerts:[{}],

      }

    }

    async componentDidMount(){
	    const searchParams = new URLSearchParams(window.location.search);
    	var closed = this.state.closed
    	var mine = this.state.mine
    	await this.getWorkOrderAlerts(closed,mine);
		this.setState({plate: searchParams.get('plate')})
    }

    getWorkOrderAlerts = () => {
	    const token = localStorage.getItem('userToken')
		axios.get(api.work_order_alerts().user_alerts(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var work_order_alerts = res.data
	      		this.setState({work_order_alerts: work_order_alerts, loaded: true})
	      })
	      .catch(err =>{console.log(err)
	      })    	
    }


	handleDownloadUserAlert = () => {
        this.setState({backdrop: true})
		const token = localStorage.getItem('userToken')
		axios.get(api.work_order_alerts().export(''),
		  {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		 )
		.then((response)=> {
			this.handleCloseBackdrop()
		    window.location.href = response.data
            this.setState({backdrop: false})
		})
		.catch(error => {
		    alert('Falló la descarga')
		})


	}

	handleCloseBackdrop = () => {
		var backdrop = !this.state.backdrop
		this.setState({backdrop: backdrop})
	}

	getMuiTheme = () =>
		createMuiTheme({
		  overrides: {
		    MuiTableCell: {
		     root: {
		       padding: '0px 8px 0px 8px',
		       fontSize: '0.73rem'
		      },

		      MuiInputLabel:{
		      	root:{
		      		fontSize: '0.70rem',
		      		color:'red'
		      	}
		      }
		    },
			MuiFormControlLabel:{
				root: {
					maxWidth: '70px',
					textAlign: 'center'
				}
			},
		    MUIDataTableToolbar:{
	    		root:{
	    			minHeight: '0px'
	    		}
		    },
		    MuiTableFooter:{
		    	root:{
		    		fontSize:'0.73rem'
		    	}
		    },
		    MuiTypography:{
		    	body2:{
		    		fontSize: '0.73rem'
		    	}
		    },
		    MuiTablePagination:{
		    	toolbar:{
		    		minHeight:'0px'
		    	}
		    },
		    MuiIconButton:{
		    	root:{
		    		padding:'4px'
		    	}
		    },
		    MUIDataTableHeadCell: {
		    	fixedHeader:{
			    	fontSize: '0.875rem'	
		    	} 
		    },
		    MuiFormLabel: {
		    	root:{
		    		fontSize: '0.75rem'
		    	}	
		    },
		    MuiInputBase:{
		    	root: {
		    		fontSize: '0.75rem'
		    	}
		    },
		    MuiTypography:{
		    	body1: {
		    		fontSize: '0.75rem'
		    	}	
		    },
		    MUIDataTableViewCol:{
			    label: {
			    	fontSize: '0.75rem'
			    }	
		    }
		  }
	});    
	
	render(){
		const classes = this.props.classes;
		const columns = [
		 {
		  name: "work_order.id",
		  label: "#",
		  options: {
		   filter: false,
		   sort: true,
		   draggable:false
		  }
		 },
		 {
            name: "subject",
            label: "Motivo Alerta",
            options: {
             filter: false,
             sort: true,
             draggable:false
            }
           },
           {
            name: "alert_date",
            label: "Fecha Alerta",
            options: {
             filter: true,
             sort: true,
             draggable:false,
             filterType: 'custom',
             customFilterListOptions: {
              render: v => {
                if (v[0] && v[1]) {
                  return [`${v[0]}`, `${v[1]}`];
                } else if (v[0]) {
                  return `${v[0]}`;
                } else if (v[1]) {
                  return `${v[1]}`;
                }
                return [];
              },
              update: (filterList, filterPos, index) => {
                if (filterPos === 0) {
                  filterList[index].splice(filterPos, 1, '');
                } else if (filterPos === 1) {
                  filterList[index].splice(filterPos, 1);
                } else if (filterPos === -1) {
                  filterList[index] = [];
                }
  
                return filterList;
              },
            },
            filterOptions: {
              names: [],
              logic(alert_date, filters) {
  //				var min = (filters[0]) ? new Date(filters[0].split('-')[2],filters[0].split('-')[1]-1,filters[0].split('-')[0]) : null
                  var min = (filters[0]) ? new Date(filters[0]) : null
                  var max = (filters[1]) ? new Date(filters[1]) : null
                  var alert_date = (alert_date) ? alert_date.split(' ')[0] : null;
                  alert_date = (alert_date) ?  new Date(alert_date.split('-')[0],alert_date.split('-')[1]-1,alert_date.split('-')[2]) : null
                  if (min && max) {
                      return !(alert_date >= min && alert_date <= max);
                  } else if (min) {
                    return !(alert_date >= min);
                  } if (max) {
                    return !(alert_date <= max);
                  }
                  return false;
              },
              display: (filterList, onChange, index, column) => (
                    <div>
                    <TextField
                      label='Fecha alerta desde'
                      InputLabelProps={{
                          shrink: true
                      }}
                      type="date"
                      value={filterList[index][0] || ''}
                      onChange={event => {
                        filterList[index][0] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%' }}
                    />
                    <TextField
                      label='Fecha alerta hasta'
                      type="date"
                      InputLabelProps={{
                          shrink: true
                      }}
                      value={filterList[index][1] || ''}
                      onChange={event => {
                        filterList[index][1] = event.target.value;
                        onChange(filterList[index], index, column);
                      }}
                      style={{ width: '45%' }}
                    />
                  </div>
              ),
            },
            }
           },
           {
            name: "next_reclaim_subject",
            label: "Proximo reclamo",
            options: {
             filter: true,
			 filterType: "text",
             sort: true,
             draggable:false
            }
           },
           {
            name: "reclaim_to",
            label: "Reclamar a",
            options: {
				filter: true,
				filterType: "text",
				sort: true,
    	        draggable:false
			}
           },
           {
            name: "reclaim_type",
            label: "Tipo de reclamo",
            options: {
             filter: true,
			 filterType: "select",
             sort: true,
             draggable:false
            }
           },
           {
            name: "work_order.contract.name",
            label: "Cliente",
	    	  options: {
    		   filter: true,
            sort: true,
            filterType: 'multiselect'
            }
		 },
		 {
		  name: "work_order.vehicle.plate",
		  label: "Patente",
		  options: {
		   filter: true,
		   sort: true,
           display: false,
		   filterType: 'textField',
		   filterList:(this.state.plate) ? [this.state.plate]: null
		  }
		 },
		 {
		  name: "work_order.type.name",
		  label: "Tipo",
		  options: {
		   filter: true,
		   sort: true,
           display: false,
		   filterType: 'multiselect',
		  }
		 },
		 {
		  name: "work_order.updated_at",
		  label: "Ult. fecha OT",
		  options: {
		   filter: false,
		   sort: true,
           display: false,
		  }
		},
		 {
		  name: "work_order.state",
		  label: "Estado OT",
		  options: {
		   filter: true,
		   sort: true,
           display: false,
		   filterType: 'multiselect',
		  }
		},
		{
		  name: "work_order.reason",
		  label: "Motivo OT",
		  options: {
		   filter: true,
		   sort: true,
		   display: true,
		   filterType: 'textField',
		  }
		 },
		 {
		  name: "work_order.contract.group",
		  label: "Grupo empresa",
		  options: {
		   filter: true,
		   sort: true,
		   display: false,
		   filterType: 'multiselect',
		  }
		},
		 {
		  name: "work_order.created_at",
		  label: "Fecha Creación OT",
		  options: {
		   filter: false,
		   sort: true,
		   display: false
		  }
		},
		 {
		  name: "work_order.km",
		  label: "KM",
		  options: {
		   filter: false,
		   sort: true,
		   display: false
		  }
		},
		 {
		  name: "work_order.vehicle.version.name",
		  label: "Vehículo",
		  options: {
		   filter: true,
		   sort: true,
		   display: false,
		   filterType: 'dropdown',
		  }
		},
		 {
		  name: "work_order.budgets.0.provider.business_name",
		  label: "Proveedor",
		  options: {
		   filter: true,
		   sort: true,
		   display: true,
		   filterType: 'dropdown',
		  }
		},
		{
		 name: "work_order.hansa_code",
		 label: "Cod. Hansa",
		 options: {
		  filter: true,
		  filterType: 'textField',
		  sort: false,
		  display: false
		 }
	   },
       {
		  name: "",
		  label: "",
		  options: {
		   filter: false,
		   sort: false,
           customBodyRender: (value, tableMeta, updateValue) => {
           	return <Fab color="primary" aria-label="edit" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2'  href={"/work-order/"+tableMeta.rowData[0]}>
                    <EditIcon fontSize="small"/> 
                  </Fab>

           }

		  }
		},
		{
			name: "layout",
			label: "layout",
			options:{
				filter: false, 
				sort: false,
				display: false,
			}
		},
		{
			name: "layout.display",
			label: "layout.display",
			options:{
				filter: false,
				sort: false,
				display: false,
			}
		}

		];


		const options = {
	      customToolbar: () => {
	        return (
	                <React.Fragment>
				        <Tooltip title={"Descargar"}>
							<IconButton onClick={(e) => {this.handleDownloadUserAlert()}}>
								<CloudDownloadIcon />
							</IconButton>
				        </Tooltip>
				        <Tooltip title={"Turnos"}>
				          <IconButton onClick={(e)=>{window.location.href="work-orders/calendar"}}>
				            <EventIcon />
				          </IconButton>
				        </Tooltip>
				        <Tooltip title={"Nuevo"}>
				          <IconButton onClick={(e)=>{window.location.href="work-order/0"}}>
				            <AddIcon />
				          </IconButton>
				        </Tooltip>
				    </React.Fragment>
	        );
	      },
		  filterType: 'checkbox',
		  rowsPerPage: 100,
		  responsieve:true,
		  draggableColumns: {
		    enabled: true,
		    transitionTime: 300
		  },	
		  enableNestedDataAccess: '.',
		  print: false,
		  download: false,
		  setRowProps: (row, dataIndex, rowIndex) => {
			var layout = row[17]
			if (layout){
				if (layout.color){
					return {
						style: { backgroundColor: layout.color },
					  };
				}
			}
		  },			  
		  textLabels: {
		      toolbar: {
		        search: "Buscar",
		        viewColumns: "Ver columnas",
		        filterTable: "Filtros",   
		        downloadCsv: "Exportar XLS",
		      },
		      body: {
		          noMatch: this.state.loaded ?
		              'No hay resultados' :
		              <CircularProgress />,
		      },
		      selectedRows: {
		        text: "fila(s) seleccionadas"
		      },
		      viewColumns: {
		        title: "Ver columnas",
		      },
		      pagination: {
		        next: "Siguiente",
		        previous: "Anteior",
		        rowsPerPage: "Cantidad por página:",
		        displayRows: "de",      
		      },
		      filter: {
		        all: "Todos",
		        title: "Filtros",
		        reset: "Limpiar"
		      }
		  }		  
		};
		return(
				<Container fluid className="main-content-container px-4">
					<Row>
						<Col className="p-2">
							{(this.state.loaded) 
							? 
								<MuiThemeProvider theme={this.getMuiTheme()}>
					                <Backdrop open={this.state.backdrop} onClick={this.handleCloseBackdrop} style={{zIndex: 10000, color: '#3f51b5'}}>
						                  <CircularProgress color="inherit" /> <Typography className="ml-2" variant="h5" color="primary">Descargando...</Typography>
					                </Backdrop>
									<MUIDataTable
										data={this.state.work_order_alerts}
                                        title="Mis alertas"
										columns={columns}
										options={options}
									/>
								</MuiThemeProvider>
							:
								<CircularProgress />
							}
						</Col>
					</Row>
				</Container>
		)
	}
}
export default withStyles(useStyles)(WorkOrderAlerts);